import React from 'react';
import LogViewer from '../components/dashboard/LogViewer';
import './LogsPage.css';

const LogsPage = () => {
    return (
        <div className="logs-page">
            <div className="logs-page-header">
                <h1>📊 Monitoring API</h1>
                <p>Surveillez les logs de l'API en temps réel pour déboguer et monitorer les performances</p>
            </div>

            <div className="logs-page-content">
                <LogViewer />
            </div>
        </div>
    );
};

export default LogsPage; 